import { Layers } from "lucide-react";

// Items still to post across the batches assigned to this assistant.
export default function Workload({ m }) {
  const w = m.workload || { batches: 0, left: 0 };
  return (
    <p className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${w.left ? "bg-[#0053DA]/10 text-[#0053DA]" : "bg-slate-100 text-slate-500"}`}
      data-testid={`team-member-workload-${m.id}`}>
      <Layers className="h-3 w-3" />
      {w.left ? <><b className="font-mono">{w.left}</b> item{w.left === 1 ? "" : "s"} left in <b className="font-mono">{w.batches}</b> assigned batch{w.batches === 1 ? "" : "es"}</> : "No assigned batches waiting"}
    </p>
  );
}
